export const DOLLAR_QUOTATION_TIME = {
  hour: 1,
  minutes: 0,
  seconds: 10,
};
